const ProductMgtList = () => import('@/modules/listmgt/ProductMgtList')
const ProductMgtListCx = () => import('@/modules/listmgt/ProductMgtListCx')
const OneProductMgt = () => import('@/modules/listmgt/OneProductMgt')
const OneProductMgtCx = () => import('@/modules/listmgt/OneProductMgtCx')
const CxdProductMgtCx = () => import('@/modules/listmgt/CxdProductMgtCx')
const EnterpriseFinancial = () => import('@/modules/listmgt/EnterpriseFinancial')
const ImportCrFundTrunOver = () => import('@/modules/listmgt/ImportCrFundTrunOver')
const LibraryProjectMgt = () => import('@/modules/listmgt/LibraryProjectMgt')
export default [
  {
    path: '/productMgtList',
    name: 'productMgtList',
    component: ProductMgtList,
    meta: {
      title: '产品管理',
      isBlack: true
    },
  },
  {
    path: '/productMgtListCx',
    name: 'productMgtListCx',
    component: ProductMgtListCx,
    meta: {
      title: '产品查询',
      isBlack: true
    },
  },
  {
    path: '/oneProductMgt',
    name: 'oneProductMgt',
    component: OneProductMgt,
    meta: {
      title: '单个产品名单库管理',

    },
  },
  {
    path: '/oneProductMgtCx',
    name: 'oneProductMgtCx',
    component: OneProductMgtCx,
    meta: {
      title: '单个产品名单库查询',

    },
  },
  {
    path: '/CxdProductMgtCx',
    name: 'CxdProductMgtCx',
    component: CxdProductMgtCx,
    meta: {
      title: '创新贷产品名单库查询',
    },
  },
  {
    path: '/enterpriseFinancial',
    name: 'enterpriseFinancial',
    component: EnterpriseFinancial,
    meta: {
      title: '财务情况（近三年）',
      isBlack: true
    },
  },
  {
    path: '/importCrFundTrunOver',
    name: 'importCrFundTrunOver',
    component: ImportCrFundTrunOver,
    meta: {
      title: '周转贷导入',
      isBlack: true
    },
  },
  {
    path: '/LibraryProjectMgt',
    name: 'LibraryProjectMgt',
    component: LibraryProjectMgt,
    meta: {
      title: '名单库管理',
      isBlack: true
    },
  },
]
